import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import AboutPage from '@/pages/about/page';
import CategoriesPage from '@/pages/categories/page';
import ProductsPage from '@/pages/products/page';
import BrandStoryPage from '@/pages/brand-story/page';
import BlogPage from '@/pages/blog/page';
import BlogDetailPage from '@/pages/blog/detail/page';
import ContactPage from '@/pages/contact/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/about', element: <AboutPage /> },

  { path: '/products', element: <ProductsPage /> },
  { path: '/brand-story', element: <BrandStoryPage /> },
  { path: '/blog', element: <BlogPage /> },
  { path: '/blog/:id', element: <BlogDetailPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
